import { Button, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@bpinternal/ui-kit-next'
import { SquarePen } from 'lucide-react'
import { useIsAuthorized } from '~/hooks'
import { getCdmStudioUrl } from '~/shared'
import { useIsAdkBot } from '~/features/bots/hooks/useIsAdkBot'

type Props = {
  workspaceId: string
  botId: string
  userId: string
  className?: string
}

export const EditInStudioButton = ({ workspaceId, userId, botId, className }: Props) => {
  const isAuthorized = useIsAuthorized({ workspaceId, userId })
  const isAuthorizedToOpenStudio = isAuthorized('studio.view') || isAuthorized('studio.edit')
  const isAdkBot = useIsAdkBot({ workspaceId, botId })

  const isDisabled = !isAuthorizedToOpenStudio || isAdkBot

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <a
            href={isDisabled ? undefined : getCdmStudioUrl(botId)}
            target="_blank"
            rel="noopener noreferrer"
            className={className}
          >
            <Button className="flex w-full items-center" disabled={isDisabled}>
              <SquarePen />
              Edit in studio
            </Button>
          </a>
        </TooltipTrigger>
        {isDisabled && (
          <TooltipContent>
            <p>
              {isAdkBot
                ? 'This is an ADK bot and can only be edited by code.'
                : 'You do not have access to this feature. Contact the owner or administrator(s) of this workspace to gain access.'}
            </p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  )
}
